<template>
  <div class="card card-table-two" style="height:360px" v-loading='loading'>
    <div class='media'>
      <div class='media-body'>
        <h6 class="card-title" style="font-size: 15px;">SMSF</h6>
      </div>
      <div class='media-body'>
        <el-input 
        style='margin-bottom:5px'
        size='mini'
        v-model="message" 
        prefix-icon="el-icon-search"
        placeholder="Search">
        </el-input>
      </div>
    </div>
    <span class="d-block mg-b-20 az-content-text"> You have <strong style="color:black">{{funds.length}}</strong> funds. Click the fund name to see fund details.</span>
    <div class="table-responsive">
        <table class="table table-striped table-dashboard-two">
        <thead>
            <tr>
            <th class="wd-lg-50p">Fund Name</th>
            </tr>
        </thead>
        <tbody >
          <tr v-for="(item,index) in funds" :key="item.fund_code">
            <td class="tx-medium" v-show="item.fund_name.toLowerCase().match(message.toLowerCase())">
              <router-link :to="{path:'/funddashboard/'+item.fund_code,query:{name:item.fund_name}}">{{isSample?'Sample Family Super Fund '+(index+1):item.fund_name}} <i class='fa fa-angle-right'></i></router-link>
            </td>
          </tr>
        </tbody>
        </table>
    </div><!-- table-responsive -->
  </div><!-- card-dashboard-five -->
</template>
<script>
// import axios from 'axios';
export default {
  name: 'SMSF',
  components:{
  },
  props: {
    
  },
  data(){
    return{
      isSample:false,
      brand:'',
      funds:[],
      message:'',
      loading:true
    }
  },
  watch:{
    message:(val)=>{
          
          
    }
  },
  beforeCreate(){
    
  },
  created(){
    this.getSMSF();
  },
  methods:{
    getSMSF: function(){
      const userdetail = JSON.parse(localStorage.getItem('userdetail'));
      let brand = localStorage.getItem('brand_code')
      this.isSample = userdetail['sample']
      this.$api.adviserdashboard_api.smsfList(brand).then(response =>{
        const funds = response.data["funds"];
        this.funds = funds;
        this.loading=false
      }) 
    }
  }
}
</script>
